import React from "react";
import BenefitSetupDetailSection from "./BenefitSetupDetailSection";
import { BaseInput, Icons, Ptag } from "components/core";
import DependentsCardList from "pages/GradeSetup/DependentsCardList";
import BaseTextArea from "components/BaseTextArea";
import { FieldArray } from "formik";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
} from "@mui/material";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import ControlPointIcon from "@mui/icons-material/ControlPoint";
import { colors } from "theme";
import { BenefitFormWrapper } from "./styles";
import { formatToRs } from "utlis/utils";

function BenefitSetupDetailGrade({ formikProps, gmcGradeCodes }) {
 
  const handleDependentsTap = (formikProps, dependent, isGrade, index) => {
    const currentDependents = isGrade
      ? formikProps.values.grades[index]?.dependents_covered || []
      : formikProps.values.dependents_covered;
    const isDependentSelected = currentDependents.includes(dependent);

    const updatedDependents = isDependentSelected
      ? currentDependents.filter((d) => d !== dependent)
      : [...currentDependents, dependent];

    if (isGrade) {
      formikProps.setFieldValue(
        `grades[${index}].dependents_covered`,
        updatedDependents
      );
    } else {
      formikProps.setFieldValue("dependents_covered", updatedDependents);
    }

    // if (isDependentSelected) {
    //   formikProps.setFieldValue(
    //     "dependents_covered",
    //     currentDependents.filter((d) => d !== dependent)
    //   );
    // } else {
    //   formikProps.setFieldValue("dependents_covered", [
    //     ...currentDependents,
    //     dependent,
    //   ]);
    // }
  };

  const renderGradeDetail = (isGrade, index) => {
    return (
      <>
        <BenefitSetupDetailSection title="Entity ID">
          <BaseInput
            fontSize="14px !important"
            placeholder="Enter Code"
            formikProps={{
              ...formikProps,
              name: isGrade ? `grades[${index}].entity_id` : "entity_id",
            }}
          />
        </BenefitSetupDetailSection>
        <BenefitSetupDetailSection title="Dependents Covered">
          <DependentsCardList
            showHeading={false}
            submitCount={formikProps.submitCount}
            handleClick={(dependent) =>
              handleDependentsTap(formikProps, dependent, isGrade, index)
            }
            selectedDependents={
              isGrade
                ? formikProps.values?.grades?.[index]?.dependents_covered || []
                : formikProps.values.dependents_covered
            }
          />
        </BenefitSetupDetailSection>
        <BenefitSetupDetailSection title="Coupon Code (optional)">
          <BaseInput
            fontSize="14px !important"
            placeholder=""
            formikProps={{
              ...formikProps,
              name: isGrade
                ? `grades[${index}].redeem_option_data`
                : "redeem_option_data",
            }}
          />
        </BenefitSetupDetailSection>
        <BenefitSetupDetailSection title="Benefit Heading">
          <BaseInput
            fontSize="14px !important"
            placeholder=""
            formikProps={{
              ...formikProps,
              name: isGrade
                ? `grades[${index}].benefit_heading`
                : "benefit_heading",
            }}
          />
        </BenefitSetupDetailSection>
        <BenefitSetupDetailSection title="Benefit Description">
          <BaseTextArea
            name={
              isGrade
                ? `grades[${index}].benefit_description`
                : "benefit_description"
            }
            customStyle={{
              fontSize: "14px",
              padding: "12.5px",
              borderRadius: "10px",
              color: colors.primaryColor,
            }}
          />
        </BenefitSetupDetailSection>
        <BenefitSetupDetailSection title="Benefit Details (optional)">
          <FieldArray
            name={
              isGrade ? `grades[${index}].benefit_details` : "benefit_details"
            }
            render={(arrayHelpers) => (
              <div>
                {isGrade
                  ? (formikProps.values.grades[index]?.benefit_details && formikProps.values.grades[index]?.benefit_details.length > 0 
                      ? formikProps.values.grades[index]?.benefit_details?.map(
                          (_, idx) => (
                            <div
                              key={idx}
                              style={{
                                marginBottom: "0.4rem",
                              }}
                            >
                              <BaseTextArea
                                name={`grades[${index}].benefit_details[${idx}]`}
                                customStyle={{
                                  fontSize: "14px",
                                  padding: "12.5px",
                                  borderRadius: "10px",
                                  color: colors.primaryColor,
                                }}
                              />
                            </div>
                          )
                        )
                      : (
                          <div
                            key={0}
                            style={{
                              marginBottom: "0.4rem",
                            }}
                          >
                            <BaseTextArea
                              name={`grades[${index}].benefit_details[0]`}
                              customStyle={{
                                fontSize: "14px",
                                padding: "12.5px",
                                borderRadius: "10px",
                                color: colors.primaryColor,
                              }}
                            />
                          </div>
                        )
                    )
                  : (formikProps.values.benefit_details && formikProps.values.benefit_details.length > 0
                      ? formikProps.values.benefit_details?.map((_, idx) => (
                          <div
                            key={idx}
                            style={{
                              marginBottom: "0.4rem",
                            }}
                          >
                            <BaseTextArea 
                              name={`benefit_details.${idx}`}
                              customStyle={{
                                fontSize: "14px",
                                padding: "12.5px",
                                borderRadius: "10px",
                                color: colors.primaryColor,
                              }}
                            />
                          </div>
                        ))
                      : (
                          <div
                            key={0}
                            style={{
                              marginBottom: "0.4rem",
                            }}
                          >
                            <BaseTextArea 
                              name={`benefit_details.0`}
                              customStyle={{
                                fontSize: "14px",
                                padding: "12.5px",
                                borderRadius: "10px",
                                color: colors.primaryColor,
                              }}
                            />
                          </div>
                        )
                    )}

                <footer
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  {isGrade
                    ? (formikProps.values.grades[index]?.benefit_details && formikProps.values.grades[index]?.benefit_details.length > 1) && (
                        <Button
                          sx={{
                              fontSize: "14px !important",
                              textDecoration: "underline",
                              textTransform: "capitalize",
                              color: "#DE6944",
                              alignItems: 'center',
                              "& .MuiButton-startIcon": {
                                marginRight: 0.25,
                              }
                            }}
                          startIcon={<RemoveCircleOutlineIcon />}
                          onClick={() =>
                            arrayHelpers.remove(
                              formikProps.values.grades[index]?.benefit_details
                                ?.length - 1
                            )
                          }
                        >
                          <Ptag color="#DE6944" fontSize={'14px'}>
                            Remove
                          </Ptag>
                        </Button>
                      )
                    : (formikProps.values.benefit_details && formikProps.values.benefit_details.length > 1) && (
                        <Button
                          sx={{
                             fontSize: "14px !important",
                              textDecoration: "underline",
                              textTransform: "capitalize",
                              color: "#DE6944",
                              alignItems: 'center',
                              "& .MuiButton-startIcon": {
                                marginRight: 0.25,
                              }
                          }}
                          startIcon={<RemoveCircleOutlineIcon />}
                          onClick={() =>
                            arrayHelpers.remove(
                              formikProps.values.benefit_details.length - 1
                            )
                          }
                        >
                        <Ptag color="#DE6944" fontSize={'14px'}>
                          Remove
                        </Ptag>
                        </Button>
                      )}

                  <Button
                    sx={{
                      fontSize: "14px !important",
                      textDecoration: "underline",
                      textTransform: "capitalize",
                      color: colors.primaryColor,
                       alignItems: 'center',
                              "& .MuiButton-startIcon": {
                                marginRight: 0.25,
                              }
                    }}
                    startIcon={<ControlPointIcon />}
                    onClick={() => arrayHelpers.push("")}
                  >
                    <Ptag fontSize='14px'>
                      Add
                    </Ptag>
                  </Button>
                </footer>
              </div>
            )}
          />
        </BenefitSetupDetailSection>

        {/* <BenefitSetupDetailSection title="Benefit Details">
          <FieldArray
            name={
              isGrade ? `grades[${index}].benefit_details` : "benefit_details"
            }
            render={(arrayHelpers) => (
              <div>
                {isGrade ? (
                  <>
                    {formikProps.values.grades[index]?.benefit_details &&
                      formikProps.values.grades[index]?.benefit_details.map(
                        (_, idx) => (
                          <div
                            key={idx}
                            style={{
                              marginBottom: "0.4rem",
                            }}
                          >
                            <BaseTextArea
                              name={`grades[${index}].benefit_details[${idx}]`}
                            />
                          </div>
                        )
                      )}
                    <footer
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                      }}
                    >
                      {formikProps?.values?.grades[index]?.benefit_details?.length >
                        1 && (
                        <Button
                          sx={{
                            fontSize: "14px !important",
                            textDecoration: "underline",
                            textTransform: "capitalize",
                            color: "#DE6944",
                          }}
                          startIcon={<RemoveCircleOutlineIcon />}
                          onClick={() =>
                            arrayHelpers.remove(
                              formikProps?.values?.grades[index]?.benefit_details
                                ?.length - 1
                            )
                          }
                        >
                          Remove
                        </Button>
                      )}
                      <Button
                        sx={{
                          fontSize: "14px !important",
                          textDecoration: "underline",
                          textTransform: "capitalize",
                          color: colors.primaryColor,
                        }}
                        startIcon={<ControlPointIcon />}
                        onClick={() => arrayHelpers.push("")}
                      >
                        Add
                      </Button>
                    </footer>
                  </>
                ) : (
                  <>
                    {formikProps.values.benefit_details &&
                      formikProps.values.benefit_details.map((_, idx) => (
                        <div
                          key={idx}
                          style={{
                            marginBottom: "0.4rem",
                          }}
                        >
                          <BaseTextArea name={`benefit_details.${idx}`} />
                        </div>
                      ))}
                    <footer
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                      }}
                    >
                      {formikProps?.values?.benefit_details?.length > 1 && (
                        <Button
                          sx={{
                            fontSize: "14px !important",
                            textDecoration: "underline",
                            textTransform: "capitalize",
                            color: "#DE6944",
                          }}
                          startIcon={<RemoveCircleOutlineIcon />}
                          onClick={() =>
                            arrayHelpers.remove(
                              formikProps.values.benefit_details.length - 1
                            )
                          }
                        >
                          Remove
                        </Button>
                      )}
                      <Button
                        sx={{
                          fontSize: "14px !important",
                          textDecoration: "underline",
                          textTransform: "capitalize",
                          color: colors.primaryColor,
                        }}
                        startIcon={<ControlPointIcon />}
                        onClick={() => arrayHelpers.push("")}
                      >
                        Add
                      </Button>
                    </footer>
                  </>
                )}
              </div>
            )}
          />
        </BenefitSetupDetailSection> */}
      </>
    );
  };

  if (formikProps?.values?.choiceType === "GRADED") {
    return (
      <FieldArray
        name="grades"
        render={({ push, pop }) => (
          <div
            style={{
              marginBottom: "12px",
            }}
          >
            {gmcGradeCodes?.map((grade, index) => (
              <Accordion
                defaultExpanded={index === 0}
                sx={{
                  boxShadow: "none",
                  border: "1px solid #F7ECFF",
                  marginBottom: "1rem",
                  borderRadius: "8px",
                }}
              >
                <AccordionSummary
                  sx={{
                    background: "#FDEFCC",
                  }}
                  expandIcon={<Icons icon="chevron_down" />}
                >
                  <div
                    style={{
                      margin: "1rem 2rem",
                      display: "flex",
                      alignItems: "flex-end",
                    }}
                  >
                    <Ptag fontWeight="600" fontSize="14px">
                      Grade {index + 1}
                    </Ptag>
                    <Ptag fontWeight="600" fontSize="14px" marginLeft="6px">
                      ({formatToRs(grade, false)})
                    </Ptag>
                  </div>
                </AccordionSummary>
                <AccordionDetails>
                  <BenefitFormWrapper
                    style={{
                      padding: "20px",
                    }}
                  >
                    {renderGradeDetail(true, index)}
                  </BenefitFormWrapper>
                </AccordionDetails>
              </Accordion>
            ))}
          </div>
        )}
      />
    );
  }

  return renderGradeDetail();
}

export default BenefitSetupDetailGrade;
